import {PHOTO_ENHANCEMENT_SERVICE_ID} from '../../shared/constants'
import {CreateSchedulerRequestModel} from './models/CreateSchedulerRequestModel'

export const mapFormValuesToCreateRequest = (values: any): CreateSchedulerRequestModel => {
  return {
    name: values.name,
    folderType: values.folderType,
    folderId: values.folderId,
    folderName: values.folderName,
    time: values.time,
    type: values.type,
    orderType: values.orderType,
    settingId: Number(values.settingId),
    verified: values.verified,
    serviceId: PHOTO_ENHANCEMENT_SERVICE_ID,
    weekDays: values.weekDays,
  }
}
